import { c as convertSearchToQuery } from "../../base/common/router.js";
function navigateRouter(router, to) {
  const search = convertQueryToSearch(to.query);
  return router.navigate(
    {
      pathname: to.path,
      hash: to.hash,
      search: search.size ? `?${search.toString()}` : void 0
    },
    {
      replace: !!to.replace
    }
  );
}
function getRelativePathname(router, pathname) {
  if (!router.basename || router.basename === "/") return pathname;
  return pathname.startsWith(router.basename) ? pathname.slice(router.basename.length) : pathname;
}
function convertRouterLocationToFederation(route) {
  const fullPath = [route.pathname, route.search, route.hash].filter(Boolean).join("");
  return {
    fullPath,
    hash: route.hash,
    path: route.pathname,
    query: convertSearchToQuery(route.search)
  };
}
function convertQueryToSearch(query) {
  const search = new URLSearchParams();
  for (const key in query) {
    const value = query[key];
    if (!value) {
      continue;
    }
    if (typeof value === "object" && Array.isArray(value)) {
      for (const item of value) {
        if (!item) {
          continue;
        }
        search.append(key, `${item}`);
      }
    } else {
      search.append(key, `${value}`);
    }
  }
  return search;
}
export {
  convertQueryToSearch as a,
  convertRouterLocationToFederation as c,
  getRelativePathname as g,
  navigateRouter as n
};
//# sourceMappingURL=router.js.map
